<template>
	<div class="app_detail clearfix p_background">
		<h3 class="all_title">应用名称</h3>
		<section class="app_detail_box tb_padding container_box clearfix">
			<div class="state_right text-right" style="width:95%;">
				<span v-if="filterFlag1" class="btn btn_issue" style="margin-left: 10px;" id="editBtn" @click='editAppCloud(appCloud.id,vId)'>编辑信息</span>

				<span v-if="filterFlag" class="btn btn_issue" style="margin-left: 10px;" id="deployBtn" @click='updateAppCloud(appCloud.id,vId)'>更新版本</span>
			</div>

			<!--应用详情头部 start-->
			<div class="details_title_box clearfix">
				<div class="photo_left inline-block">
					<div class="photo_info" style="width:160px; height: 160px; border-radius:32px;">
						<div class="img_default hidden"></div>
						<img class="img_default" :src="logoPath" id="app_icon_first" alt="" />
					</div>
					<span class="intro_title inline-block">版本编号：</span>
					<span class="intro_text inline-block">{{appCloud.tcloudAppVersion.versionNo}}</span>
				</div>
				<div class="intro_right inline-block">
					<h4>{{appCloud.appName}}</h4>
					<div class="right_box clearfix">
						<section class="col-sm-6 right_box_left">
							<p>
								<span class="intro_title inline-block">应用状态：</span>
								<span class="intro_text inline-block" v-if="appCloud.appStatus == '3'">禁止销售</span>
								<span class="intro_text inline-block" v-else-if="showStatus == '9'">准备提交</span>
								<span class="intro_text inline-block" v-else-if="showStatus == '0'">等待审核</span>
								<span class="intro_text inline-block" v-else-if="showStatus == '3'">正在审核</span>
								<span class="intro_text inline-block" v-else-if="showStatus == '2'">审核被拒</span>
								<span class="intro_text inline-block" v-else-if="showStatus == '1' && showPublicStatus == '0'">等待上架</span>
								<span class="intro_text inline-block" v-else-if="showStatus == '1' && showPublicStatus == '1' && appCloud.appStatus == '1'">可供销售</span>
								<span class="intro_text inline-block" v-else-if="appCloud.appStatus == '2'">暂停销售</span>
							</p>
							<p>
								<span class="intro_title inline-block">上线日期：</span>
								<span class="intro_text inline-block">{{appCloud.tcloudAppVersion.publishTime?appCloud.tcloudAppVersion.publishTime:''|time}}</span>
							</p>
							<p>
								<span class="intro_title inline-block">应用分类：</span>
								<span class="intro_text inline-block" v-for="option in appTypeOptions" v-if="appCloud.businessType==option.id">{{ option.dictionaryname }}</span>
							</p>
							<p>
								<span class="intro_title inline-block">群体范围：</span>
								<span class="intro_text inline-block">{{ appCloud.tcloudAppVersion.userScope }}</span>
							</p>
						</section>
						<section class="col-sm-6 right_box_right">
							<p>
								<span class="intro_title inline-block">增值服务：</span>
								<span class="intro_text inline-block">{{ appCloud.tcloudAppVersion.addserviceApis }}</span>
							</p>
							<p>
								<span class="intro_title inline-block">部署类型：</span>
								<span class="intro_text inline-block">私有云部署</span>
							</p>
							<p>
								<span class="intro_title inline-block">数据接口权限：</span>
								<span class="intro_text inline-block">{{ appCloud.tcloudAppVersion.misdataApis }}</span>
							</p>
						</section>
					</div>
					<!-- right_box/ -->
				</div>
			</div>
			<!-- details_title_box/ -->
			<!--应用详情头部 end-->

			<!--应用简介 start-->
			<div class="details_presentation_box word-bw">
				<h5 class="ht5">应用介绍：</h5>
				<p class="color_9">{{appCloud.tcloudAppVersion.appComment}}</p>
			</div>
			<!--应用简介 end-->

			<!--审核记录 start-->

			<div class="details_record_box">
				<h5 class="ht5">审核记录：</h5>
				<!--<el-collapse v-model="activeName" accordion>
					<el-collapse-item  v-for="(audit,index) in appVersionAuditList" :key="audit.appVersionAuditList" :title="audit.inputTime?audit.inputTime:''|time" name="index">
						<div>{{audit.inputUser}}【{{audit.appname}} {{audit.versionno}}】</div>
						<div>
							<span class="state state_not" v-if="audit.inspectStatus == '2'">不通过</span>
							<span class="state state_success" v-if="audit.inspectStatus == '1'">通过</span>
						</div>
						<div>{{audit.inspectComment}}</div>
					</el-collapse-item>
				</el-collapse>-->
				<section v-if="appVersionAuditList.length > 0">
					<p class="color_9 line_block cursor" v-for="audit in appVersionAuditList">
						<span class="time text-space">{{audit.inputTime?audit.inputTime:''|time}}</span>
						<span class="name text-space" data-toggle="tooltip" data-placement="bottom" title="管理员【名称v.1.0.1】">{{audit.inputUser}}【{{audit.appname}} {{audit.versionno}}】</span>
						<span class="state state_not" v-if="audit.inspectStatus == '2'">不通过</span>
						<span class="state state_success" v-if="audit.inspectStatus == '1'">通过</span>
						<span class="text text-space" data-toggle="tooltip" data-placement="bottom" :title="audit.inspectComment">
							{{audit.inspectComment}}
						</span>
					</p>
				</section>
				<section v-else>
					<p class="color_9">&nbsp;&nbsp;&nbsp;&nbsp;暂无审核记录</p>
				</section>
			</div>

			<!--审核记录 end-->

			<!--应用截图 start-->

			<div class="details_screenshot_box">
				<h5 class="ht5">屏幕截图：</h5>
				<el-carousel :interval="4000" type="card" height="300px">
					<el-carousel-item v-for="(pic,index) in appCloudFiles" :key="pic.appCloudFiles">
						<div class="item">
							<img :src="pic.filePath">
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>
			<!--应用截图 end-->
			<!--反馈评论 start-->

			<div class="details_feedback_box" v-if="appCloudCommentPage.length>0">
				<h5 class="ht5">反馈评论：</h5>
				<p class="sub_title h6 cursor">全部评论<span>({{appCloudCommentPage.length}})</span></p>
				<ul class="feedback_list">
					<li v-for="comment in filterCommentList">
						<section class="head_img">
							<div class="head_img_box center-block img-circle">
								<img src="" alt="" />
							</div>
						</section>
						<section class="content">
							<p class="content_title clearfix tip_sub_text">
								<span class="pull-left">
									<span>用户名</span>
								<i class="star">{{comment.userName}}</i>
								</span>
								<small class="pull-right">
									评论版本：
									<b>{{comment.versionNo}}</b>
									<b>{{comment.commentTime|time}}</b>
								</small>
							</p>
							<p class="h6 color_9">
								{{comment.comment}}
							</p>
						</section>
					</li>
				</ul>
				<a v-if="appCloudCommentPage.length>5" href="javascript:void(0)" v-on:click='loadMore'>查看更多</a>
			</div>
			<input type="hidden" v-model="pageNumber" />

			<!--反馈评论 end-->
		</section>
	</div>
</template>

<script>
	export default {
		name: 'app_detail',
		data() {
			return {
				appTypeOptions: '',
				appRange: '',
				appCloud: {
					id: '',
					appName: '',
					appEnName: '',
					appType: '',
					businessType: '',
					deployType: '',
					appClinetid: '',
					appClinetsercet: '',
					appversionid: '',
					uploadUser: '',
					specialType: '',
					delFlag: '',
					authCode: '',
					authType: '',
					inputTime: '',
					inputUser: '',
					updateTime: '',
					updateUser: '',
					appStatus: '',
					tcloudAppVersion: {
						id: '',
						appid: '',
						versionNo: '',
						appComment: '',
						appInstallpackagePath: '',
						versionComment: '',
						publishTime: '',
						misdataApis: '',
						addserviceApis: '',
						visitUrl: '',
						userScope: '',
						inspectStatus: '',
						publishStatus: '',
						delFlag: '',
						inputTime: '',
						inputUser: '',
						updateTime: '',
						updateUser: '',
						publishType: '',
					}
				},
				appId: '',
				vStatus: '',
				appCloudCommentPage: [],
				appCloudFiles: '',
				appVersionList: '',
				appVersionAuditList: '',
				rangeList: '',
				pageNumber: 0,
				logoPath: '',
				showFalg: false,
				limitNum: 5,
				vId: '',
				vPublicStatus: '',
				appCount: 0,
				flag: false
			}
		},
		// 页面初始化
		created: function() {
			var $this = this;
			//应用id
			this.appId = this.$route.params.appid;
			this.vPublicStatus = this.$route.params.publicStatus;
			this.vId = this.$route.params.vId;
			this.appCount = this.$route.params.appCount;
			//查询字典
			this.getSystemConfigList();
			//查询应用详细信息
			this.getAppCloudDetial(function() {
				//查询附件
				$this.getAppCloudFiles();
				//查询版本审核详情
				$this.getAppVersionAuditList();
				//查询评论
				$this.getAppCloudComments();
				//logo路径
				$this.loadLogo();
			});
		},
		computed: {
			filterCommentList: function() {
				return this.appCloudCommentPage.slice(0, this.limitNum);
			},
			showStatus: function() {
				if(this.$route.params.vStatus) {
					this.vStatus = this.$route.params.vStatus;
					return this.$route.params.vStatus;
				}
			},
			showPublicStatus: function() {
				if(this.$route.params.vpublicStatus) {
					this.vPublicStatus = this.$route.params.vpublicStatus;
					return this.$route.params.vpublicStatus;
				}
			},
			filterFlag: function() {
				if((this.appCloud.appStatus == '1' || this.appCloud.appStatus == '2') && this.$route.params.vStatus == '1' && this.$route.params.appCount <= 1 && this.appCloud.deployType != '109003') {

					return true;
				} else {

					return false;
				}
			},
			filterFlag1: function() {
				if(this.appCloud.appversionid == this.$route.params.vId) {
					if(this.$route.params.vStatus == '3' || this.appCloud.appStatus == '3') {

						return false;
					} else {

						return true;
					}
				} else {
					if(this.$route.params.vStatus == '3') {

						return false;
					} else {

						return true;
					}
				}

			}
		},
		methods: {
			getSystemConfigList() {
				var temp = this;
				this.$http.post('/zklccloud/queryAllTCloudSysDictionary',  { emulateJSON: true }).then(function(m) {
					for(var key in m.body.dictionaryMap) {
						if(key == '应用分类') {
							temp.appTypeOptions = m.body.dictionaryMap[key];
						} else if(key == '群体范围') {
							temp.appRange = m.body.dictionaryMap[key];
						}
					}
				})
			},
			getAppCloudDetial(callback) {
				var _this = this;
				this.$http.post('/zklccloud/findTCloudAppById', { "appid": this.appId, "versionId": this.vId }, { emulateJSON: true }).then(function(m) {
					_this.appCloud = m.body.content.tCloudApp
					if(callback) {
						callback()
					}

				})
			},
			getAppCloudFiles() {
				var temp = this;
				this.$http.post('/zklccloud/findTCloudAppFilesById', { "appversionid": this.appCloud.appversionid }, { emulateJSON: true }).then(function(m) {
					temp.appCloudFiles = m.body.content.appFiles
				})
			},
			getAppCloudComments(page) {
				var temp = this;
				this.$http.post('/zklccloud/findTCloudAppCommentById', { "appid": this.appId }, { emulateJSON: true }).then(function(m) {
					temp.appCloudCommentPage = m.data.content.page
				})
			},
			getAppVersionAuditList() {
				var temp = this;
				this.$http.post('/zklccloud/findAuditRecords', { "appId": this.appId }, { emulateJSON: true }).then(function(m) {
					temp.appVersionAuditList = m.body
				})
			},
			loadMore: function() {
				this.limitNum = this.appCloudCommentPage.length;
			},
			loadLogo() {
				var temp = this;
				this.$http.post('/zklccloud/apps/toGetAppImagePath', { "appVersionId": this.appCloud.appversionid, "fileType": '108001' }, { emulateJSON: true }).then(function(m) {
					temp.logoPath = m.body.data
				})
			},
			editAppCloud(id, appversionid) {
				if(this.appCount == 2) {
					this.flag = true;
				}
				this.$router.push({
					name: 'publish_apply',
					params: { appid: id, appVersionId: appversionid, versioncontent: this.flag, inspertStatus: this.appCloud.tcloudAppVersion.inspectStatus }
				});
			},
			updateAppCloud(id, appversionid) {
				if(this.appCount == 2) {
					this.flag = true;
				}
				this.$router.push({
					name: 'edit_app',
					params: { appid: id, appVersionId: appversionid, versioncontent: this.flag }
				});
			}
		},
	}
</script>

<style scoped>
	.details_title_box .right_box_left p {
		margin-top: 0px !important;
	}
	
	#app_icon_first {
		width: 160px;
		height: 160px;
		border-radius: 32px;
	}
</style>


// WEBPACK FOOTER //
// app_detail.vue?5414d738